<template>
  <v-app>
    <my-snackbar />
    <!-- <home v-if="showNavbar" />
    <home-member v-if="showNavbar" />-->
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </v-app>
</template>

<script>
import MySnackbar from "@/components/snackbar/MySnackbar";
//import Home from "@/views/home/Home";
//import HomeMember from "@/views/home/HomeMember";

export default {
  name: "App",
  // components: { MySnackbar, Home, HomeMember },
  components: { MySnackbar },
  data: () => ({
    //
  }),
  computed: {
    showNavbar() {
      console.log("HOME showNavbar this.$route.name:", this.$route.name);
      return this.$route.name !== "login" && this.$route.name != null;
    }
  }
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
a {
  text-decoration: none;
}
</style>
